export const addressToString = (address) => {
  if (!address) return null;
  const { streetAddress, city, province, postalCode } = address;
  return `${streetAddress}, ${city}, ${province}, ${postalCode}`;
};
